var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2287 2.20164C16.8535 2.74556 16.9191 3.69304 16.3752 4.31789L15.1763 5.69512C15.7616 5.62545 16.3694 5.58706 17.0003 5.58706C24.6145 5.58706 30.7828 11.7553 30.7828 19.3696C30.7828 26.9838 24.6145 33.1521 17.0003 33.1521C9.38601 33.1521 3.21777 26.9838 3.21777 19.3696C3.21777 16.5406 4.0767 13.9012 5.53803 11.7092C5.99756 11.0199 6.92886 10.8336 7.61816 11.2931C8.30745 11.7527 8.49371 12.684 8.03418 13.3733C6.88884 15.0913 6.21777 17.1551 6.21777 19.3696C6.21777 25.327 11.0429 30.1521 17.0003 30.1521C22.9577 30.1521 27.7828 25.327 27.7828 19.3696C27.7828 13.4122 22.9577 8.58706 17.0003 8.58706C16.2023 8.58706 15.4481 8.66321 14.7334 8.79518L16.8082 10.3097C17.4773 10.7981 17.6238 11.7365 17.1353 12.4056C16.6469 13.0748 15.7085 13.2212 15.0394 12.7328L10.2854 9.26248C10.2445 9.2336 10.2047 9.2024 10.1661 9.16888C10.0741 9.08922 9.99399 9.00034 9.92605 8.90462C9.63159 8.49038 9.56963 7.95427 9.75336 7.48714C9.80139 7.36504 9.8662 7.24765 9.94804 7.13838C9.97533 7.10184 10.004 7.0669 10.0339 7.03356L14.1124 2.34817C14.6563 1.72332 15.6038 1.65771 16.2287 2.20164Z",
    fill: "#5387A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate_left.48738dbba0c20194e893a2ed5637950b.svg";
export { ForwardRef as ReactComponent };